// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"7188d610","498":"2ddc1d57","598":"ddad9bf1","787":"87dade37"}[chunkId] + ".chunk.js";
};